/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datetime1Inputs */

const en_datetime1 = /** @type {(inputs: Datetime1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date & Time`)
};

const de_datetime1 = /** @type {(inputs: Datetime1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum und Uhrzeit`)
};

/**
* | output |
* | --- |
* | "Date & Time" |
*
* @param {Datetime1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const datetime1 = /** @type {((inputs?: Datetime1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datetime1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_datetime1(inputs)
	return de_datetime1(inputs)
});
export { datetime1 as "dateTime" }